import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import {  IconButton, LinearProgress, Pagination, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

const exportToCsv = (messages) => {
  const rows = messages.map((message) => {
    return {
      ThreadLink: `${process.env.REACT_APP_FRONTEND_URL}/?thread-id=${message.threadId}`,
      Rating: message.rating,
      Review: message.review,
      CreatedAt: `${new Date(message.createdAt).toLocaleString()} (${Intl.DateTimeFormat().resolvedOptions().timeZone})`,
    };
  });

  // Convert rows to CSV
  const headers = ["ThreadLink", "Rating", "Review", "CreatedAt"];
  const csvString = [
    headers.join(","), // Add headers row
    ...rows.map((row) =>
      headers
        .map((header) => `"${row[header]?.replace(/"/g, '""') || ""}"`)
        .join(",")
    ),
  ].join("\n");

  // Create a Blob and trigger download
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const fileName = "messages_export.csv";
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
}

export default function AllReviews() {
  const [messages, setMessages] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
//   const [limit, setLimit] = useState(10);

const fetchMessagesForExport = async (records) => {
    const token = localStorage.getItem("auth-token");
    const response = await axios.get(
    `${process.env.REACT_APP_BACKEND_URL}/export-all-reviews`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data.reviews
  
};

const [loadingExport, setLoadingExport] = useState(false)

const onExport = async (e) => {
  e.preventDefault();
  setLoadingExport(true);

  try {
    const messages = await fetchMessagesForExport(totalRecords);

    exportToCsv(messages);

    console.log("Export completed!");
  } catch (error) {
    console.error("Export failed:", error);
  } finally {
    setLoadingExport(false);
  }
};


const limit = 10;
  const fetchMessages = async (search = "") => {
    try {
      setLoading(true);
      const token = localStorage.getItem("auth-token");
      const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/reviews?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  
    setMessages(response.data.reviews);
      setTotalRecords(response.data.totalRecords);
      setLoading(false);
    } catch (error) {
      navigate("/login");
    } finally {
      setLoading(false);
    }
  };
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    fetchMessages();
  }, [page]);

if(loading) {
  return <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
  <LinearProgress color="success" sx={{width: '20%'}}/>
  </div>
}
  return (
    <Container>
      <Content>
        <h1 style={{color: "green"}}>All Reviews</h1>
        <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
          <div style={{display: 'flex', gap: '1rem', alignItems: 'center'}}>

          
          </div>
          <div style={{display: 'flex', gap: '1rem', alignItems: 'center', float: 'right'}}>
         
        
           <button style={{
            padding: "0.5rem",
            borderRadius: "0.5rem",
            border: "1px solid #ccc",
            backgroundColor: loadingExport ? "#ccc" : "green",
            // backgroundColor: 'green',
            color: "white",
            float: 'right',
            cursor: 'pointer'
          }}
          onClick={(e) => onExport(e)}
          >Export all reviews</button>
          </div>
        </div>
        <TableWrapper>
          <table style={{width: "100%", borderCollapse: "separate", borderSpacing: "0 8px"}}>
            <thead>
              <tr>
                <th style={{color: "black", padding: "10px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)"}} width="15%">Thread ID</th>
                <th style={{color: "black", padding: "10px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)"}} width="10%">Rating</th>
                <th style={{color: "black", padding: "10px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)"}} width="60%">Review</th>
                <th style={{color: "black", padding: "10px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)"}} width="5%">Actions</th>
              </tr>
            </thead>
            <tbody>
              {messages.map((message, index) => (
                <tr key={message._id} style={{backgroundColor: index % 2 === 0 ? "white" : "#b5e5b5"}}>
                 
                  <td style={{color: "black", padding: "10px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", textAlign: 'center'}}><a href={`${process.env.REACT_APP_FRONTEND_URL}/?thread-id=${message.threadId}&user=admin`} target="_blank" rel="noopener noreferrer">{message.threadId}</a></td>
                  <td style={{color: "black", padding: "10px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", textAlign: 'center'}}>{message.rating || '-'}</td>
                  <td style={{color: "black", padding: "10px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)",}}>
                   {message.review}
                  </td>
                  <td style={{color: "black", padding: "10px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)"}}>
                    <div style={{display: "flex", gap: "0.5rem",}}>
                  <Tooltip title="View Chat"
                  onClick={() => window.open(`${process.env.REACT_APP_FRONTEND_URL}/?thread-id=${message.threadId}&user=admin`, '_blank')}>
                  <IconButton>
                    <RemoveRedEyeIcon />
                  </IconButton>
                  </Tooltip>
                 
                  </div>
                  </td>
                </tr>

              ))}
            </tbody>
          </table>
        </TableWrapper>
        <Pagination
          sx={{
            marginTop: "1rem",
            "& .MuiPaginationItem-root": {
              color: "black",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              "&:hover": {
                backgroundColor: "grey",
              },
              "&.Mui-selected": {
                backgroundColor: "grey",
              },
            },
          }}
          count={Math.ceil(totalRecords / limit)}
          page={page}
          onChange={(event, value) => {
            setPage(value);
          }}
        />
      </Content>
    </Container>
  );
  
}


const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  overflow-y: auto;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  padding: 2rem;
  width: 100%;
  // max-width: 1200px;
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;
